import React, {Component} from 'react'
import {Typeahead} from 'react-bootstrap-typeahead-ali/dist/react-bootstrap-typeahead'
import {Row, FormControl} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import englishRegex from '../../../utils/validateNewHorse'

class Breeder extends Component {
  constructor (props) {
    super(props)
    this.state = {
      term: props.breeder || '',
      options: [],
      message: props.breeder_fa ? props.breeder_fa : props.breeder,
      language: '',
      showTranslateField: false,
      translated: props.breeder_fa || '',
      id: null,
      isLoading: false,
      sealed: false
    }
    this.timeout = null
    this.seek = this.seek.bind(this)
    this.pickOption = this.pickOption.bind(this)
    this.changeKeyword = this.changeKeyword.bind(this)
    this.persistValues = this.persistValues.bind(this)
    this.updateTranslation = this.updateTranslation.bind(this)
    this.validate = this.validate.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      translate: this.state.language === 'fa' ? nextProps.breeder : nextProps.breeder_fa,
      term: this.state.language === 'fa' ? nextProps.breeder_fa : nextProps.breeder,
      id: nextProps.breeder_id,
      sealed: !!nextProps.breeder_id
    })
  }

  persistValues () {
    const {language, translated, term, id, sealed} = this.state
    if (sealed) { return undefined }
    Actions.setNewHorseDetails({
      breeder: language === 'fa' ? translated : term,
      breeder_fa: language === 'fa' ? term : translated,
      breeder_id: id
    })
    Actions.validateNewHorseData()
  }

  updateTranslation (e) {
    let termLang = (/^[-. \w]+$/.test(e.target.value)) ? 'fa' : 'en'
    this.setState({translated: e.target.value, language: termLang}, () => this.persistValues())
  }

  seek (keyword) {
    Actions.breederSeek(keyword).then((res) => {
      if (res.data.length === 0) {
        this.setState({options: [], message: 'موردی یافت نشد'})
      } else {
        this.setState({options: res.data, message: ''})
      }
    })
  }

  pickOption (picked) {
    if (picked.length === 0) { return undefined }
    if (picked[0].customOption) {
      this.setState({isLoading: true})
      return Actions.translate(picked[0].name).then((res) => {
        this.setState({
          language: res.data.charType,
          isLoading: false,
          translated: res.data.translate === picked[0].name ? '' : res.data.translate,
          breeder: picked[0].name,
          id: undefined,
          sealed: false,
          showTranslateField: true
        }, () => this.persistValues())
      }).catch((e) => {
        this.setState({language: picked[0].name.match(englishRegex) ? 'en' : 'fa', isLoading: false, id: undefined, translated: '', breeder: picked[0].name, showTranslateField: true, sealed: false}, () => this.persistValues())
      })
    }
    let id = picked[0].customOption ? undefined : parseInt(picked[0].id, 10)
    let lang = (/^[-. \w]+$/.test(picked[0].name)) ? 'en' : 'fa'
    Actions.setNewHorseDetails({
      breeder_id: id,
      breeder: '',
      breeder_fa: ''
    })
    this.setState({language: lang, showTranslateField: false, sealed: true})
    Actions.clearNewHorseTouched()
    Actions.validateNewHorseData()
  }

  changeKeyword (keyword) {
    this.setState({message: keyword, term: keyword}, () => this.persistValues())
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (keyword.length > 0) {
      this.timeout = setTimeout(() => {
        Actions.breederSeek(keyword).then((res) => {
          if (res.data.length === 0) {
            this.setState({options: [], message: 'موردی یافت نشد'})
          } else {
            this.setState({options: res.data, message: ''})
            Actions.validateNewHorseData()
          }
        })
      }, 400)
    } else {
      this.setState({message: '', options: []})
    }
  }

  validate () {
    setTimeout(() => {
      Actions.clearNewHorseTouched()
      Actions.addNewHorseTouched('breeder_id')
      Actions.addNewHorseTouched('breeder')
      Actions.addNewHorseTouched('breeder_fa')
      Actions.validateNewHorseData()
    }, 500)
  }

  render () {
    const {options, message, translated, language, isLoading, showTranslateField} = this.state
    const {placeholder, touched, errors} = this.props

    const hasError = (field) => {
      if (errors && touched && touched.indexOf(field) !== -1) {
        return errors[field]
      }
    }

    return (
      <Row>
        {isLoading && <p>چند لحظه...</p>}
        <Typeahead
          onChange={this.pickOption}
          onInputChange={this.changeKeyword}
          emptyLabel={message}
          placeholder={placeholder}
          className={`Name blink ${hasError('breeder') || hasError('breeder_id') ? 'form-component-error' : ''} `}
          labelKey="name"
          options={options}
          onBlur={this.validate}
          newSelectionPrefix="پرورش‌دهنده جدید "
          allowNew
        />

        {showTranslateField && language &&
          <FormControl
            name="mongos"
            placeholder="معادل"
            className={`form-control ${hasError('breeder_fa') ? 'form-component-error' : ''} `}
            value={translated}
            onChange={this.updateTranslation}
            onBlur={() => { Actions.addNewHorseTouched('breeder_fa'); Actions.validateNewHorseData() }}
          />
        }
      </Row>
    )
  }
}

Breeder.propTypes = {
  breeder: React.PropTypes.string,
  breeder_fa: React.PropTypes.string,
  breeder_id: React.PropTypes.number,
  placeholder: React.PropTypes.string.isRequired,
  errors: React.PropTypes.object,
  touched: React.PropTypes.array
}

export default Breeder



// WEBPACK FOOTER //
// ./src/components/NewHorse/Breeder/Breeder.js